import Vue from 'vue'
import VueRouter from 'vue-router'
import Signin from '../views/Signin.vue'
import Signup from '../views/Signup.vue'
import About from '../views/About.vue'
import PasswordGenerator from '../views/PasswordGenerator.vue'
import Passwords from '../views/Passwords.vue'
import ImportPasswords from '../views/ImportPasswords.vue'
import Notes from '../views/Notes.vue'
import Settings from '../views/Settings.vue'
import InitializePin from '../views/InitializePin.vue'
import UpdatePin from '../views/UpdatePin.vue'
import EnterPin from '../views/EnterPin.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Signin',
    component: Signin
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  },
  {
    path: '/passwordgenerator',
    name: 'PasswordGenerator',
    component: PasswordGenerator
  },
  {
    path: '/passwords',
    name: 'Passwords',
    component: Passwords
  },
  {
    path: '/passwords/import',
    name: 'Import Passwords',
    component: ImportPasswords
  },
  {
    path: '/notes',
    name: 'Notes',
    component: Notes
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/pin/initialize',
    name: 'InitializePin',
    component: InitializePin
  },
  {
    path: '/pin/update',
    name: 'UpdatePin',
    component: UpdatePin
  },
  {
    path: '/pin/enter',
    name: 'EnterPin',
    component: EnterPin
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
